import tippy from "tippy.js";
import { Z_INDEX } from "~/jose_modern/hint_util.js";
import { onViewLoad } from "~/jose_modern/on_view_load.js";
import { once } from "~/jose_modern/once.js";
import { initEditTitle } from "../shared/edit_title.js";

const SESSION_KEY = "po_filter_by_supplier";
let filterBySupplier = sessionStorage.getItem(SESSION_KEY) === "true";

function dispatchSupplierFilter(supplierId) {
  document.dispatchEvent(new CustomEvent("supplier-filter-changed", { detail: { supplierId } }));
}

function dispatchOrderSupplier(supplierId, supplierName) {
  document.dispatchEvent(
    new CustomEvent("order-supplier-changed", { detail: { supplierId, supplierName } })
  );
}

function selectedSupplierName(supplierSelect) {
  const option = supplierSelect.options[supplierSelect.selectedIndex];
  return option ? option.text : null;
}

function initSupplierFilter(container) {
  const supplierSelect = container.querySelector("#purchase_order_supplier_id");
  if (!supplierSelect) return;

  const orderSupplierId = +supplierSelect.value || null;
  dispatchOrderSupplier(orderSupplierId, selectedSupplierName(supplierSelect));

  once(supplierSelect, "order-supplier-change", () => {
    supplierSelect.addEventListener("change", () => {
      const id = +supplierSelect.value || null;
      dispatchOrderSupplier(id, selectedSupplierName(supplierSelect));
    });
  });

  const checkbox = container.querySelector("[data-supplier-filter]");
  if (!checkbox) {
    dispatchSupplierFilter(null);
    return;
  }

  checkbox.checked = filterBySupplier;

  once(checkbox, "supplier-filter", () => {
    checkbox.addEventListener("change", () => {
      filterBySupplier = checkbox.checked;
      sessionStorage.setItem(SESSION_KEY, filterBySupplier);
      const supplierId = +supplierSelect.value || null;
      dispatchSupplierFilter(filterBySupplier ? supplierId : null);
    });
  });

  dispatchSupplierFilter(filterBySupplier ? orderSupplierId : null);
}

function initActivateButton() {
  once(document, "activate-button", () => {
    const tippyInstances = [];
    let itemsEmpty = true;
    let hasUnsaved = false;

    document.querySelectorAll("[data-activate-button]").forEach((btn) => {
      const wrapper = document.createElement("span");
      wrapper.style.display = "inline-block";
      btn.parentNode.insertBefore(wrapper, btn);
      wrapper.appendChild(btn);

      const tippyInstance = tippy(wrapper, {
        theme: "recipal",
        appendTo: document.body,
        zIndex: Z_INDEX,
      });
      tippyInstance.disable();
      tippyInstances.push({ btn, tippyInstance });
    });

    const updateActivateButtons = () => {
      tippyInstances.forEach(({ btn, tippyInstance }) => {
        if (itemsEmpty) {
          btn.disabled = true;
          tippyInstance.setContent("Add at least one item to activate this order");
          tippyInstance.enable();
        } else if (hasUnsaved) {
          btn.disabled = true;
          tippyInstance.setContent("Save all items before activating");
          tippyInstance.enable();
        } else {
          btn.disabled = false;
          tippyInstance.disable();
        }
      });
    };

    // We get one of each event once the component is mounted, making sure
    // the states are always in sync
    document.addEventListener("order-items-changed", ({ detail }) => {
      itemsEmpty = detail.count === 0;
      updateActivateButtons();
    });

    document.addEventListener("order-items-has-unsaved", ({ detail }) => {
      hasUnsaved = detail.hasUnsaved;
      updateActivateButtons();
    });
  });
}

const scan = (container) => {
  initActivateButton();
  initEditTitle(container);
  initSupplierFilter(container);
};

onViewLoad("purchase_orders#edit", () => {
  scan(document);
  document.addEventListener("partial:replace", (ev) => scan(ev.container));
  document.addEventListener("clear-supplier-filter", () => {
    const checkbox = document.querySelector("[data-supplier-filter]");
    if (!checkbox) return;
    filterBySupplier = false;
    sessionStorage.setItem(SESSION_KEY, false);
    checkbox.checked = false;
    dispatchSupplierFilter(null);
  });
});
